export const FETCH_USER_REQUEST = 'user/FETCH_REQUEST';
export const FETCH_USER_SUCCESS = 'user/FETCH_SUCCESS';
export const FETCH_USER_FAILURE = 'user/FETCH_FAILURE';

export const fetchUserRequest = () => ({ type: FETCH_USER_REQUEST });
export const fetchUserSuccess = payload => ({ type: FETCH_USER_SUCCESS, payload });
export const fetchUserFailure = () => ({ type: FETCH_USER_FAILURE });

export const fetchUser = userId => (dispatch, getState, { request }) => {
  dispatch(fetchUserRequest());

  const promise = request(`/_api/users/${userId}`);

  return promise
    .then(user => dispatch(fetchUserSuccess(user)))
    .catch(() => dispatch(fetchUserFailure()))
    .then(() => promise);
};



// WEBPACK FOOTER //
// ./app/actions/fetch-user.js